/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { identityResolve } from "../funcs/identityResolve.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { IdentityModel } from "../models/components/identitymodel.js";
import {
  ResolveIdentityRequest,
  ResolveIdentitySecurity,
} from "../models/operations/resolveidentity.js";
import { unwrapAsync } from "../types/fp.js";
export type IdentityQueryData = IdentityModel;

export function prefetchIdentity(
  queryClient: QueryClient,
  client$: GramCore,
  request: ResolveIdentityRequest,
  security?: ResolveIdentitySecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildIdentityQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildIdentityQuery(
  client$: GramCore,
  request: ResolveIdentityRequest,
  security?: ResolveIdentitySecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<IdentityQueryData>;
} {
  return {
    queryKey: queryKeyIdentity({
      urn: request.urn,
      gramKey: request.gramKey,
      gramSession: request.gramSession,
    }),
    queryFn: async function identityQueryFn(ctx): Promise<IdentityQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(identityResolve(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyIdentity(
  parameters: {
    urn: string;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "identity", "resolve", parameters];
}
